import styled from '@emotion/styled';
import { Rating } from '@mui/material';
import React, { useState } from 'react'
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { customStyles } from '../../../styles';
export const RatingStars = (props) => {
    const [value, setValue] = useState(props?.rating)
    const StyledRating = styled(Rating)({
      '& .MuiRating-iconFilled': {
        color: customStyles.colors.main,
      },
      '& .MuiRating-iconHover': {
        color: customStyles.colors.secondary,
      },
    });
    
  return (
    // <Rating
    // name="simple-controlled"
    // value={value}
    // onChange={(event, newValue) => {
    //     setValue(newValue);
    // }}
    // />
    <StyledRating
      name="customized-color"
      defaultValue={props?.rating}
      getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
      precision={0.5}
      icon={<StarRoundedIcon fontSize="inherit" />}
      emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
      onChange={(event, newValue) => {
             setValue(newValue);
         }}
      readOnly
    />
  )
}